import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './VisionSection.css';
import { renderTextWithNormalDash } from '../../utils/textFormatters';
import { Link } from 'react-router-dom';

const VisionSection = ({ page = "home", title, subtext, listordesc, buttontext = "", subtexttwo = "", subtextthree = "", img }) => {
    const titlesplitted = title ? title.split(" ") : [];
    const titleTextcut = titlesplitted.slice(0, -1).join(" ");
    const titleGradient = titlesplitted.slice(-1).join(" ");
    return (
        <section className="vision-section">
            <Container>
                <div className="vision-card">
                    <Row className="g-4 align-items-center">
                        <Col lg={page === "specific-service" ? 6 : 8}>
                            <div className="vision-image-wrap">
                                <img src={page === "home" ? "/vision.png" : page === "about" ? "/our-story.png" : img} alt="Luxury eyewear" className="img-fluid vision-image" />
                            </div>
                        </Col>
                        <Col lg={page === "specific-service" ? 6 : 4}>
                            <div className="vision-copy">
                                <h2 className="vision-title">
                                    {titleTextcut} <span className="vision-accent">{titleGradient}</span>
                                </h2>
                                <p className="vision-lead">
                                    {renderTextWithNormalDash(subtext)}
                                </p>
                                {listordesc.length !== 4 ? (
                                    <>
                                        {/* <p className="vision-lead">
                                            {renderTextWithNormalDash(subtext)}
                                        </p> */}
                                        {subtexttwo && (
                                            <p className='vision-lead'>
                                                {renderTextWithNormalDash(subtexttwo)}
                                            </p>)
                                        }
                                        {subtextthree && (
                                            <p className='vision-lead'>
                                                {renderTextWithNormalDash(subtextthree)}
                                            </p>)
                                        }
                                        {
                                            listordesc.length === 1 ? <p className="vision-lead">
                                                {renderTextWithNormalDash(listordesc[0])}
                                            </p> : (
                                                <ul className="vision-list">

                                                    {listordesc.map((item, index) => (
                                                        <li key={index}>
                                                            {renderTextWithNormalDash(item)}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )
                                        }
                                    </>
                                ) : (
                                    <ul className="vision-list">
                                        <li>
                                            <div className="vision-list-title">{listordesc[0]}</div>
                                            <div className="vision-list-sub">{listordesc[1]}</div>
                                        </li>
                                        <li>
                                            <div className="vision-list-title">{renderTextWithNormalDash(listordesc[2])}</div>
                                            <div className="vision-list-sub">{renderTextWithNormalDash(listordesc[3])}</div>
                                        </li>
                                    </ul>
                                )
                                }
                                {buttontext && page !== "specific-service" && <Button as={Link} to="/about" className="vision-cta" >{buttontext}</Button>}
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </section>
    );
};

export default VisionSection;